import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../../../../page-components/common/DataElementContext';
import evBus from '../../../../utils/evbus';
import { useAppSelector, useAppDispatch } from '../../../../store';
import { ticketOpenedListRequest } from '../../../../modules/bets/store/actions/tickets';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

type MyTicketsTogglerProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
    eventBusType?: string;
  };
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const MyTicketsToggler = (componentProps: MyTicketsTogglerProps) => {
  let props = componentProps;
  let isVisible = true;

  const dataElementContext = React.useContext(DataElementContext);
  [props, isVisible] = processComponentProps(props, dataElementContext);

  const { ticketsCounterEnabled } = window.config;

  const dispatch = useAppDispatch();
  const authentication = useAppSelector((state) => state.authentication);
  const bets = useAppSelector((state) => state.bets);

  const ticketsOpened = bets.tickets.ticketsOpened;

  const [state, setState] = React.useState({
    open: false,
  });
  const eventBusType = props.properties?.eventBusType;

  const onToggle = React.useCallback(() => {
    setState((prevState) => {
      return {
        ...prevState,
        open: !prevState.open,
      };
    });
  }, []);

  React.useEffect(() => {
    if (ticketsCounterEnabled === '1' && authentication.access_token) {
      dispatch(ticketOpenedListRequest());
    }
  }, [authentication.access_token, ticketsCounterEnabled, dispatch]);

  React.useEffect(() => {
    if (eventBusType) {
      evBus.on(eventBusType, onToggle);
    }

    return () => {
      if (eventBusType) {
        evBus.remove(eventBusType, onToggle);
      }
    };
  }, [eventBusType, onToggle]);

  const contextValue = React.useMemo(() => {
    return {
      open: state.open,
      onToggle: onToggle,
      ticketsOpened,
      parentContext: dataElementContext,
    };
  }, [state, onToggle, ticketsOpened, dataElementContext]);

  if (!isVisible) {
    return null;
  }

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default MyTicketsToggler;
